'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
var theme_common_primitives_defaultPrimitives = require('../primitives/defaultPrimitives.js');
require('../primitives/commonPrimitives.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);

function getIconSizeTokens() {
  var sizes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : theme_common_primitives_defaultPrimitives.defaultSizePrimitives;
  return {
    'icon-small': sizes['16'],
    'icon-medium': sizes['24'],
    'icon-large': sizes['32'],
    'icon-xLarge': sizes['40'],
    'icon-xxLarge': sizes['48']
  };
}
function getSpaceTokens() {
  var sizes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : theme_common_primitives_defaultPrimitives.defaultSizePrimitives;
  return {
    0: sizes['0'],
    2: sizes['2'],
    4: sizes['4'],
    6: sizes['6'],
    8: sizes['8'],
    10: sizes['10'],
    12: sizes['12'],
    14: sizes['14'],
    16: sizes['16'],
    18: sizes['18'],
    20: sizes['20'],
    22: sizes['22'],
    24: sizes['24'],
    26: sizes['26'],
    28: sizes['28'],
    30: sizes['30'],
    32: sizes['32'],
    36: sizes['36'],
    38: sizes['38'],
    40: sizes['40'],
    48: sizes['48']
  };
}
function getSizeTokens() {
  var sizes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : theme_common_primitives_defaultPrimitives.defaultSizePrimitives;
  return _objectSpread__default["default"](_objectSpread__default["default"]({}, sizes), getIconSizeTokens(sizes));
}

exports.getIconSizeTokens = getIconSizeTokens;
exports.getSizeTokens = getSizeTokens;
exports.getSpaceTokens = getSpaceTokens;
//# sourceMappingURL=spacing.js.map
